import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ROUTES from '../../../../utils/routes'
import { Table } from '../../../../System'
import { StyledEarnings } from '.'
import { MONTH, YEAR } from '../../../../utils/stripePrices'
import { SkeletonLoader } from '../../../../SkeletonLoader'
import { AffiliateEarningFindMany_affiliateEarningFindMany } from '../../../../../graphql/AffiliateEarning/__generated__/AffiliateEarningFindMany'
import useAffiliateDashboard from '../../../AffiliateDashboard/useAffiliateDashboard'

const Earnings: FC = () => {
  const { loading, earnings, totalEarnings } = useAffiliateDashboard()

  const [monthEarnings, setMonthEarnings] = useState<
    AffiliateEarningFindMany_affiliateEarningFindMany[]
  >([])
  const [annualEarnings, setAnnualEarnings] = useState<
    AffiliateEarningFindMany_affiliateEarningFindMany[]
  >([])
  const [courseEarnings, setCourseEarnings] = useState<
    AffiliateEarningFindMany_affiliateEarningFindMany[]
  >([])

  const segmentEarnings = () => {
    setMonthEarnings(earnings.filter((earning) => earning.item?._id === MONTH))
    setAnnualEarnings(earnings.filter((earning) => earning.item?._id === YEAR))
    setCourseEarnings(
      earnings.filter(
        (earning) => earning.item?._id && earning.item?._id !== YEAR && earning.item?._id !== MONTH
      )
    )
  }

  const getEarningType = (category: 'month' | 'annual' | 'course') => {
    switch (category) {
      case 'annual':
        return annualEarnings
      case 'month':
        return monthEarnings
      default:
        return courseEarnings
    }
  }

  const getEarningBreakdown = (
    category: 'month' | 'annual' | 'course',
    type: 'count' | 'amount'
  ) => {
    const earning = getEarningType(category)

    switch (type) {
      case 'count':
        return earning.length
      case 'amount':
        return earning.reduce((total, earning) => {
          return total + earning.amount
        }, 0)
    }
  }

  useEffect(() => {
    segmentEarnings()
  }, [earnings])

  return (
    <StyledEarnings>
      <div className="heading">
        <h2>Earning Breakdown</h2>
        <p>
          Affiliates can earn in two different ways. To learn more, see how it works{' '}
          <Link to={ROUTES.affiliates.works}>here</Link>.
        </p>
      </div>

      <div className="earning-metrics">
        {loading && <SkeletonLoader type="caption-list-item" quantity={1} />}
        {!loading && (
          <>
            <div className="earning-table">
              <Table
                headings={['Items', 'Users', 'Total Earnings']}
                rows={[
                  [
                    'Monthly Subscription',
                    getEarningBreakdown('month', 'count'),
                    `$${getEarningBreakdown('month', 'amount').toFixed(2)}`
                  ],
                  [
                    'Annual Subscription',
                    getEarningBreakdown('annual', 'count'),
                    `$${getEarningBreakdown('annual', 'amount').toFixed(2)}`
                  ],
                  [
                    'Courses',
                    getEarningBreakdown('course', 'count'),
                    `$${getEarningBreakdown('course', 'amount').toFixed(2)}`
                  ]
                ]}
                responsive
              />
            </div>
            <span className="earning-metric">
              Total Earnings <b>${totalEarnings.toFixed(2)}</b>
            </span>
          </>
        )}
      </div>
    </StyledEarnings>
  )
}

export default Earnings
